module.exports = __webpack_public_path__ + "media/images/brand/favicon-05-6d3cc2cdb41d68d6cb362ec9bc38969d.png";